<div class="user-main catalog-content">
    <div class="form-group">
        <mat-form-field>
            <mat-select
                disableOptionCentering
                placeholder="Section"
                [(ngModel)]="activeTab"
                name="reason"
                #reason="ngModel"
                required
            >
                <mat-option
                    *ngFor="let item of categoryList"
                    [value]="item.section"
                >
                    {{ item.val }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="col-lg-12">

        <table
            class="table"
            [svData]="helpData"
            #sv="svDataTable"
            [svRowsOnPage]="pageSize"
            *ngIf="helpData && helpData.length > 0 && activeTab === 'let-us-help'"
        >
            <thead>
                <tr>
                    <th class="text-center">Name</th>
                    <th class="text-center">Phone #</th>
                    <th class="text-center">Delete</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of sv.data">
                    <td class="text-center">{{ item.name }}</td>
                    <td class="text-center">{{ item.phoneNum }}</td>
                    <td class="text-center">
                        <img
                            src="assets/icons/delete_icon.png"
                            class="cursor-pointer"
                            (click)="deleteData(item.id, 4)"
                        >
                    </td>
                </tr>
            </tbody>
            <tfoot *ngIf="helpData?.length > pageSize">
                <tr>
                    <td
                        colspan="4"
                        class="center-paginator"
                    >
                        <sv-bootstrap-paginator></sv-bootstrap-paginator>
                    </td>
                </tr>
            </tfoot>
        </table>
        <div *ngIf="helpData && helpData?.length <= 0 && activeTab === 'let-us-help'">No data found</div>


        <table
            class="table"
            [svData]="callData"
            #sv="svDataTable"
            [svRowsOnPage]="pageSize"
            *ngIf="callData && callData.length > 0 && activeTab === 'call-back'"
        >
            <thead>
                <tr>
                    <th class="text-center">Name</th>
                    <th class="text-center">Phone #</th>
                    <th class="text-center">Email</th>
                    <th class="text-center">City</th>
                    <th class="text-center">Message</th>
                    <th class="text-center">Delete</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of sv.data">
                    <td class="text-center">{{ item.name }}</td>
                    <td class="text-center">{{ item.mobileNo }}</td>
                    <td class="text-center">{{ item.emailId }}</td>
                    <td class="text-center">{{ item.city }}</td>
                    <td
                        class="text-center reduce-text cursor-pointer"
                        [display]="item.message"
                        [tooltip]="item.message"
                        placement="top"
                        show-delay="50"
                    >
                        {{ item.message }}
                    </td>
                    <td class="text-center">
                        <img
                            src="assets/icons/delete_icon.png"
                            class="cursor-pointer"
                            (click)="deleteData(item.id, 1)"
                        >
                    </td>
                </tr>
            </tbody>
            <tfoot *ngIf="callData?.length > pageSize">
                <tr>
                    <td
                        colspan="6"
                        class="center-paginator"
                    >
                        <sv-bootstrap-paginator></sv-bootstrap-paginator>
                    </td>
                </tr>
            </tfoot>
        </table>
        <div *ngIf="callData && callData?.length <= 0 && activeTab === 'call-back'">No data found</div>


        <table
            class="table"
            [svData]="writeData"
            #sv="svDataTable"
            [svRowsOnPage]="pageSize"
            *ngIf="writeData && writeData.length > 0 && activeTab === 'write-us'"
        >
            <thead>
                <tr>
                    <th class="text-center">Name</th>
                    <th class="text-center">Phone #</th>
                    <th class="text-center">Email</th>
                    <th class="text-center">City</th>
                    <th class="text-center">Reason</th>
                    <th class="text-center">Message</th>
                    <th class="text-center">Delete</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of sv.data">
                    <td class="text-center">{{ item.name }}</td>
                    <td class="text-center">{{ item.mobileNo }}</td>
                    <td class="text-center">{{ item.emailId }}</td>
                    <td class="text-center">{{ item.city }}</td>
                    <td
                        class="text-center"
                        [display]="item.reason"
                        [tooltip]="item.reason"
                        placement="top"
                        show-delay="300"
                    >
                        {{ item.reason }}
                    </td>
                    <td
                        class="text-center reduce-text cursor-pointer"
                        [display]="item.message"
                        [tooltip]="item.message"
                        placement="top"
                        show-delay="50"
                    >
                        {{ item.message }}
                    </td>
                    <td class="text-center">
                        <img
                            src="assets/icons/delete_icon.png"
                            class="cursor-pointer"
                            (click)="deleteData(item.id, 0)"
                        >
                    </td>
                </tr>
            </tbody>
            <tfoot *ngIf="writeData?.length > pageSize">
                <tr>
                    <td
                        colspan="6"
                        class="center-paginator"
                    >
                        <sv-bootstrap-paginator></sv-bootstrap-paginator>
                    </td>
                </tr>
            </tfoot>
        </table>
        <div *ngIf="writeData && writeData?.length <= 0 && activeTab === 'write-us'">No data found</div>


        <table
            class="table"
            [svData]="careerData"
            #sv="svDataTable"
            [svRowsOnPage]="pageSize"
            *ngIf="careerData && careerData.length > 0 && activeTab === 'careers'"
        >
            <thead>
                <tr>
                    <th class="text-center">Name</th>
                    <th class="text-center">Position</th>
                    <th class="text-center">Mobile #</th>
                    <th class="text-center">Email</th>
                    <th class="text-center">Message</th>
                    <th class="text-center">Resume</th>
                    <th class="text-center">Delete</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of sv.data">
                    <td class="text-center">{{ item.name }}</td>
                    <td class="text-center">{{ item.postApplied }}</td>
                    <td class="text-center">{{ item.mobileNo }}</td>
                    <td class="text-center">{{ item.emailId }}</td>
                    <td
                        class="text-center reduce-text cursor-pointer"
                        [display]="item.message"
                        [tooltip]="item.message"
                        placement="top"
                        show-delay="50"
                    >
                        {{ item.message }}
                    </td>
                    <td class="text-center cursor-pointer">
                        <img
                            src="assets/icons/icon_view.png"
                            (click)="viewFile(item.url)"
                        >
                    </td>
                    <td class="text-center cursor-pointer">
                        <img
                            src="assets/icons/delete_icon.png"
                            (click)="deleteData(item.id, 2)"
                        >
                    </td>
                </tr>
            </tbody>
            <tfoot *ngIf="careerData?.length > pageSize">
                <tr>
                    <td
                        colspan="6"
                        class="center-paginator"
                    >
                        <sv-bootstrap-paginator></sv-bootstrap-paginator>
                    </td>
                </tr>
            </tfoot>
        </table>
        <div *ngIf="careerData && careerData?.length <= 0 && activeTab === 'careers'">No data found</div>
    </div>
</div>
